/**
 * Magic Actions for YouTube — YouTube playback enhancer
 *
 * Declares a single web-accessible resource — `eopt30.html` — but scopes its `matches`
 * to `https://www.chromeactions.com/` alone rather than to every origin. The file is
 * genuinely unreachable from anywhere else, so only the vendor's own site can detect the
 * extension; a negative result from any other page proves nothing.
 *
 * That makes this a scoped detector: we set `requiredOrigin` and fetch the one resource.
 *
 * Manifest verified against version 7.9.5.6.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'abjcfabbhafbcdfjoecdgepllmpfceif';

export const magicActions: ExtensionDefinition = {
  id: ID,
  name: 'Magic Actions for YouTube™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 700_000,
  requiredOrigin: 'https://www.chromeactions.com',
  notes:
    'Its one WAR, eopt30.html, is scoped to chromeactions.com, so only that site can ' +
    'detect it — everywhere else the resource is unreachable and a miss is inconclusive.',
  signals: [
    {
      id: 'war-eopt30-html',
      kind: 'web-accessible-resource',
      description:
        'Fetch eopt30.html — the sole web-accessible resource, exposed only to ' +
        'www.chromeactions.com.',
      weight: 1,
      run: () => probeFetch(ID, 'eopt30.html'),
    },
  ],
};
